export default __webpack_public_path__ + "static/media/rating_5.98553335.svg";